<template>
    <div>
        <div v-if="notificationsLength" class="p-3 text-base text-yellow-500">Notificações: {{ notificationsLength }}</div>
        <div v-if="!notificationsLength" class="p-3">Nenhuma notificação</div>
        <div
            v-if="notificationsLength"
            class="h-64 overflow-y-scroll"
            >
            <NotificationItem
                v-for="(item, index) in notifications"
                :key="index"
                :notification="item"
            />
        </div>
    </div>

</template>

<script>
import NotificationItem from '@/components/Notifications/NotificationItem'
import { find as NotificationFind } from '@/repositories/warnings'
import { redirectInvalidUser, getMobSessid } from '../../functions'

export default {
  name: 'NotificationList',
  data () {
    return {
      notifications: [],
      notificationsLength: null
    }
  },
  components: {
    NotificationItem
  },
  mounted () {
    this.getNotifications()
  },
  methods: {
    async getNotifications () {
      const mobsessid = getMobSessid()

      if (mobsessid == null) {
        redirectInvalidUser()
        return
      }

      const response = await NotificationFind(mobsessid)
      if (response.status == 200 &&
                response.data[0]) {
        this.notifications = response.data
        this.notificationsLength = this.notifications.length
      }
      this.$emit(
        'notifications-count',
        this.notificationsLength ? this.notificationsLength : 0
      )
    }
  }
}
</script>
